import { AlertRulesData } from "./data";

export function alertRulesFromJson(json) {
  return new AlertRulesData({
    id: json.alertId,
    name: json.alertName,
    summary: json.alertWording,
    description: json.alertExplanation,
    categoryId: json.catId,
    fleetLowerLimit: json.fleetLowerLimit,
    fleetUpperLimit: json.fleetUpperLimit,
    vessels: json.vessels
  });
}
